'use client';

import { ThemeProvider } from '@blufin/react';
import type { ReactNode } from 'react';
import { themes } from '../themes';

/**
 * Root client-side provider tree for the shakacams-web Next.js app. Renders
 * with explicit default appearance — persistence is no longer plumbed through
 * the provider (settings module owns persistence in apps that need it).
 * @param root0 - Component props.
 * @param root0.children - The page content to render inside the provider tree.
 */
const Providers = ({ children }: { children: ReactNode }) => (
  <ThemeProvider initialMode="system" initialTheme={themes[0].name} themes={themes}>
    {children}
  </ThemeProvider>
);

export { Providers };
